import React, { Component } from 'react';
import { connect } from 'react-redux';
import YearCalendarView from '../components/views/YearCalendar';
import { withRouter } from '../helpers/withRouter';
import {
  addLog,
  changeSelectedUser,
  closeModal,
  openModal,
  removeLog,
  requestDatesWithlogs,
  requestDayLogs,
  updateLog,
  updateModal,
} from '../redux/actions';
import type {
  Holiday,
  LogRequest,
  Project,
  SingleModalState,
  State,
  User,
} from '../types';

type Props = {
  logsById: object,
  datesWithLogs: Array<string>,
  dateTotals: {[date: string]: number},
  currentUser: User,
  users: Array<User>,
  projects: Array<Project>,
  categories: any,
  selectedUser: User,
  routeParams: object,
  navigate: object,
  onAddLog: (projectId: any, formData: any) => Promise<any>,
  onUpdateLog: (projectId: any, logId: any, formData: any) => Promise<any>,
  onRemoveLog: (projectId: any, logId: any) => Promise<any>,
  onSelectedDayChange: (date: string, userId: any) => any,
  onRequestDatesWithLogs: (year: number, userId: number) => any,
  onSelectedUserChange: (user: User) => Promise<any>,
  onOpenModal: (args: any) => any,
  onCloseModal: (args: any) => any,
  onUpdateModal: (args: any) => any,
  router: object,
  location: object,
  holidays: Array<Holiday>,
  vacations: object,
}

class YearCalendar extends Component<Props> {
  render(): React.ReactNode {
    return (
      <YearCalendarView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: State, ownProps: Props) => ({
  logsById: state.logs.logsById,
  datesWithLogs: state.logs.datesWithLogs,
  dateTotals: state.logs.dateTotals,
  currentUser: state.currentUser,
  users: state.users,
  projects: state.projectsDropdown,
  selectedUser: state.selectedUser,
  routeParams: (ownProps as any).router.params,
  categories: state.categories,
  holidays: state.holidays,
  vacations: state.vacations,
  navigate: (ownProps as any).router.navigate,
});

const mapDispatchToProps = dispatch => ({
  onAddLog: (projectId: number, log: LogRequest) => dispatch(addLog(projectId, log)),
  onUpdateLog: (projectId: number, logId: number, log: LogRequest) => dispatch(updateLog(projectId, logId, log)),
  onRemoveLog: (projectId: number, logId: number) => dispatch(removeLog(projectId, logId)),
  onRequestDatesWithLogs: (year: number, userId: number) => dispatch(requestDatesWithlogs(year, userId)),
  onSelectedDayChange: (date: string, userId: number) => dispatch(requestDayLogs(date, userId)),
  onSelectedUserChange: (selectedUserId: number) => dispatch(changeSelectedUser(selectedUserId)),
  onOpenModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  onCloseModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
  onUpdateModal: (modal: SingleModalState) => dispatch(updateModal(modal)),
});

const ConnectedYearCalendar = withRouter(connect(mapStateToProps, mapDispatchToProps)(YearCalendar as any));

export default ConnectedYearCalendar;
